export const categories = [
  {
    name: "Shoes",
    nameDe: "Schuhe",
    namePt: "Sapatos",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=Pair%20of%20retro%20white%20leather%20sneakers%20with%20gum%20sole%20on%20soft%20cream%20studio%20backdrop%2C%20clean%20minimal%20product%20photography%20with%20soft%20shadows%20and%20warm%20natural%20lighting%2C%20high%20detail%20editorial%20style&width=600&height=450&seq=cat-shoes-01&orientation=landscape"
  },
  {
    name: "Hoodies/Sweaters",
    nameDe: "Hoodies/Pullover",
    namePt: "Moletom/Suéter",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20beige%20hoodie%20folded%20neatly%20on%20light%20wooden%20surface%20with%20soft%20morning%20light%2C%20minimal%20fashion%20flat%20lay%20product%20photography%20with%20neutral%20warm%20tones&width=600&height=450&seq=cat-hoodie-02&orientation=landscape"
  },
  {
    name: "T-Shirts",
    nameDe: "T-Shirts",
    namePt: "Camisetas",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-air-line",
    image: "https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20t-shirt%20hanging%20on%20minimal%20wooden%20hanger%20against%20warm%20greige%20wall%2C%20soft%20natural%20light%2C%20clean%20editorial%20apparel%20product%20photography&width=600&height=450&seq=cat-tshirt-03&orientation=landscape"
  },
  {
    name: "Jackets",
    nameDe: "Jacken",
    namePt: "Jaquetas",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-windy-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20laid%20flat%20on%20warm%20sand%20colored%20linen%20fabric%2C%20minimal%20editorial%20fashion%20product%20photography%20with%20soft%20diffused%20lighting&width=600&height=450&seq=cat-jacket-04&orientation=landscape"
  },
  {
    name: "Pants/Shorts",
    nameDe: "Hosen/Shorts",
    namePt: "Calças/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-scissors-line",
    image: "https://readdy.ai/api/search-image?query=Well%20tailored%20khaki%20chino%20pants%20neatly%20folded%20on%20neutral%20stone%20background%2C%20minimal%20product%20photography%20with%20soft%20warm%20lighting%20and%20clean%20composition&width=600&height=450&seq=cat-pants-05&orientation=landscape"
  },
  {
    name: "Headwear",
    nameDe: "Kopfbedeckung",
    namePt: "Chapéus/Bonés",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-star-line",
    image: "https://readdy.ai/api/search-image?query=Classic%20navy%20baseball%20cap%20on%20light%20neutral%20pedestal%20with%20soft%20studio%20lighting%2C%20minimal%20accessory%20product%20photography%20with%20clean%20cream%20background&width=600&height=450&seq=cat-headwear-06&orientation=landscape"
  },
  {
    name: "Sets",
    nameDe: "Sets",
    namePt: "Conjuntos",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Matching%20athleisure%20track%20set%20in%20soft%20gray%20folded%20in%20stack%20on%20warm%20white%20surface%2C%20minimal%20fashion%20flat%20lay%20product%20photography%20with%20gentle%20natural%20light&width=600&height=450&seq=cat-sets-07&orientation=landscape"
  },
  {
    name: "Underwear/Underpants",
    nameDe: "Unterwäsche",
    namePt: "Roupa Íntima",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shield-user-line",
    image: "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20basics%20neatly%20arranged%20on%20soft%20blush%20background%2C%20minimal%20product%20photography%20with%20clean%20composition%20and%20soft%20diffused%20studio%20light&width=600&height=450&seq=cat-underwear-08&orientation=landscape"
  },
  {
    name: "Jersey",
    nameDe: "Trikots",
    namePt: "Jerseys",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-heart-line",
    image: "https://readdy.ai/api/search-image?query=Authentic%20soccer%20jersey%20in%20red%20and%20white%20folded%20on%20neutral%20gray%20backdrop%2C%20minimal%20sports%20apparel%20product%20photography%20with%20soft%20studio%20lighting&width=600&height=450&seq=cat-jersey-09&orientation=landscape"
  },
  {
    name: "Accessories",
    nameDe: "Accessoires",
    namePt: "Acessórios",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-key-2-line",
    image: "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20minimal%20fashion%20accessories%20watch%20sunglasses%20and%20bracelet%20on%20warm%20beige%20surface%2C%20clean%20editorial%20flat%20lay%20product%20photography&width=600&height=450&seq=cat-accessories-10&orientation=landscape"
  },
  {
    name: "Bags",
    nameDe: "Taschen",
    namePt: "Bolsas",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-shopping-bag-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20tan%20leather%20crossbody%20bag%20on%20minimal%20light%20gray%20pedestal%2C%20clean%20luxury%20accessory%20product%20photography%20with%20soft%20warm%20studio%20lighting&width=600&height=450&seq=cat-bags-11&orientation=landscape"
  },
  {
    name: "Belts",
    nameDe: "Gürtel",
    namePt: "Cintos",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-links-line",
    image: "https://readdy.ai/api/search-image?query=Handcrafted%20brown%20leather%20belt%20coiled%20elegantly%20on%20neutral%20cream%20background%2C%20minimal%20product%20photography%20with%20soft%20natural%20lighting%20and%20clean%20composition&width=600&height=450&seq=cat-belts-12&orientation=landscape"
  },
  {
    name: "Perfumes",
    nameDe: "Parfums",
    namePt: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    image: "https://readdy.ai/api/search-image?query=Luxury%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20soft%20warm%20white%20surface%20with%20gentle%20light%20reflection%2C%20minimal%20elegant%20product%20photography&width=600&height=450&seq=cat-perfumes-13&orientation=landscape"
  },
  {
    name: "Other Stuff",
    nameDe: "Sonstiges",
    namePt: "Outros",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=Assorted%20curated%20lifestyle%20products%20headphones%20wallet%20and%20keychain%20arranged%20on%20warm%20neutral%20background%2C%20minimal%20flat%20lay%20product%20photography%20with%20soft%20lighting&width=600&height=450&seq=cat-other-14&orientation=landscape"
  }
];

export const mainSiteUrl = "https://kaspreadsheet.com";